import { render, staticRenderFns } from "./culturalNewsedit.vue?vue&type=template&id=0229abbe&scoped=true&"
import script from "./culturalNewsedit.vue?vue&type=script&lang=js&"
export * from "./culturalNewsedit.vue?vue&type=script&lang=js&"
import style0 from "./culturalNewsedit.vue?vue&type=style&index=0&id=0229abbe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229abbe",
  null
  
)

component.options.__file = "culturalNewsedit.vue"
export default component.exports